(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1333],{

/***/ 35035:
/***/ (function(module) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),

/***/ 14259:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 8400:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(14259),
    isIterateeCall = __webpack_require__(16612),
    toInteger = __webpack_require__(40554);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),

/***/ 38811:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suport-clienti",
      function () {
        return __webpack_require__(16855);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./lib/structuredData.js
var structuredData = __webpack_require__(89229);
;// CONCATENATED MODULE: ./components/BreadcrumbSchema.js




var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, baseUrl = _publicRuntimeConfig.settings.baseUrl;
var BreadcrumbSchema = function(param) {
    var breadcrumbData = param.breadcrumbData, currentPath = param.currentPath;
    // Do not include home page
    // Do not include pages without parent
    if (breadcrumbData && breadcrumbData.length > 1) {
        var itemListElement = breadcrumbData.map(function(breadcrumb, index) {
            return {
                "@type": "ListItem",
                position: index + 1,
                name: breadcrumb.name,
                item: breadcrumb.level != 99 ? "".concat(baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || "") : "".concat(baseUrl).concat(currentPath)
            };
        });
        var schema = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: itemListElement
        };
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: (0,structuredData/* default */.Z)(schema)
            }
        }));
    }
    return null;
};
/* harmony default export */ var components_BreadcrumbSchema = (BreadcrumbSchema);

;// CONCATENATED MODULE: ./components/Breadcrumbs.js








var Breadcrumbs_ref = (0,config["default"])(), settings = Breadcrumbs_ref.publicRuntimeConfig.settings;
var isBricoStore = settings.websiteName === "bricostore";
var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, _isPDP = param.isPDP, isPDP = _isPDP === void 0 ? false : _isPDP, className = param.className;
    var router = (0,next_router.useRouter)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            breadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BreadcrumbSchema, {
                breadcrumbData: breadcrumbs,
                currentPath: router.asPath
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Breadcrumbs is-hidden-in-mobile-app pb-3 lg:py-3 truncate text-sm ".concat(className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                    className: "p-0 m-0 list-none inline",
                    children: breadcrumbs.map(function(breadcrumb, index) {
                        return breadcrumb.level != 99 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: classnames_default()("inline", {
                                "text-red-brand": isBricoStore || !isPDP,
                                "text-[#1D4ED8]": !isBricoStore && isPDP
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "".concat(settings.baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        title: breadcrumb.name,
                                        className: classnames_default()({
                                        }),
                                        children: breadcrumb.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mx-1",
                                    children: "/"
                                })
                            ]
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "inline",
                            children: breadcrumb.name
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index));
                    })
                })
            })
        ]
    }));
};
Breadcrumbs.propTypes = {
    breadcrumbs: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        level: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired,
        url_key: function(props, propName) {
            if (props["level"] !== 99 && (typeof props[propName] !== "string" || props[propName].length === 0)) {
                return new Error("Please provide url_key when item level is not 99.");
            }
        },
        url_suffix: (prop_types_default()).string
    })).isRequired
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 96936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15722);



var HtmlEmbed = function(props) {
    var createMarkup = function(content) {
        return {
            __html: content
        };
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: props.className,
        children: [
            props.html && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: createMarkup(props.html)
            }),
            props.script && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: _lib_helpers__WEBPACK_IMPORTED_MODULE_2__/* .setDangerousHtml.bind */ .RR.bind(null, props.script)
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (HtmlEmbed);


/***/ }),

/***/ 13890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var InputRadio = function(props) {
    var input = props.input, _meta = props.meta, touched = _meta.touched, error = _meta.error;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
            className: "Form-checkbox flex items-center ".concat(props.className ? props.className : "", " ").concat(props.disabled ? "disabled" : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({}, input, {
                    id: props.id,
                    type: "radio",
                    disabled: props.disabled,
                    className: "checkbox-input opacity-0 w-0 h-0 ".concat(touched && error ? "error" : "")
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "checkbox-control is-radio flex-none w-5 h-5 p-1 mr-2 border-gray-1600 hover:border-black border rounded-full bg-white ".concat(props.required ? "is-required" : ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        width: "10",
                        height: "10",
                        viewBox: "0 0 10 10",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "10",
                            height: "10",
                            rx: "5",
                            fill: "#319D10"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "inline-block leading-18.2 ".concat(props.labelClass),
                    children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: props.label
                        },
                        className: "inline-block"
                    }) : props.label
                })
            ]
        })
    }));
};
InputRadio.defaultProps = {
    disabled: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (InputRadio);


/***/ }),

/***/ 97995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var FullWidthSection = function(param) {
    var children = param.children, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "transparent" : _backgroundColor, _padding = param.padding, padding = _padding === void 0 ? "py-6" : _padding, _classProvided = param.classProvided, classProvided = _classProvided === void 0 ? "" : _classProvided, bgImmage = param.bgImmage;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative w-screen ".concat(backgroundColor, " ") + classProvided,
        style: {
            left: "50%",
            right: "50%",
            marginLeft: "-50vw",
            marginRight: "-50vw",
            backgroundImage: bgImmage !== undefined ? "url(".concat(bgImmage, ")") : "",
            backgroundRepeat: bgImmage !== undefined ? "no-repeat" : "",
            backgroundPosition: bgImmage !== undefined ? "right 3% bottom 7%" : "",
            backgroundSize: bgImmage !== undefined ? "160px 160px" : ""
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container ".concat(padding),
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FullWidthSection);


/***/ }),

/***/ 21260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Support_Feedback; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
// EXTERNAL MODULE: ./store/app/actions.js
var actions = __webpack_require__(27173);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
// EXTERNAL MODULE: ./components/Form/Radio.js
var Radio = __webpack_require__(13890);
;// CONCATENATED MODULE: ./containers/Support/FeedbackForm.js





var FeedbackForm = function(param1) {
    var submitFeedback = param1.submitFeedback;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
        onSubmit: submitFeedback,
        render: function(param) {
            var handleSubmit = param.handleSubmit, submitting = param.submitting;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit,
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "block text-base mb-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "feedback",
                            component: Radio/* default */.Z,
                            label: "Informatii mai usor de inteles",
                            type: "radio",
                            value: "Informatii mai usor de inteles"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "block text-base",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "feedback",
                            component: Radio/* default */.Z,
                            label: "Informatii mai relevante",
                            type: "radio",
                            value: "Informatii mai relevante"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-6 mb-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            display: "inline",
                            disabled: submitting,
                            type: "submit",
                            title: "Trimite"
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var Support_FeedbackForm = (FeedbackForm);

;// CONCATENATED MODULE: ./containers/Support/Feedback.js







function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var Feedback = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(Feedback, Component1);
    var _super = _createSuper(Feedback);
    function Feedback() {
        _classCallCheck(this, Feedback);
        var _this;
        _this = _super.apply(this, arguments);
        _defineProperty(_assertThisInitialized(_this), "state", {
            vote: null,
            formIsActive: true
        });
        var _this1 = _assertThisInitialized(_this);
        _defineProperty(_assertThisInitialized(_this), "voteHandler", function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee(type) {
                var values, voteRes, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            values = _args.length > 1 && _args[1] !== void 0 ? _args[1] : null;
                            _ctx.next = 3;
                            return (0,api/* submitSupportVoteApi */.Kiw)(type, _objectSpread({
                                article_slug: _this1.props.articleSlug,
                                category_slug: _this1.props.categorySlug
                            }, values ? {
                                form: values
                            } : null));
                        case 3:
                            voteRes = _ctx.sent;
                            if (voteRes.ok) {
                                _ctx.next = 7;
                                break;
                            }
                            _this1.props.addAlert({
                                message: "Nu s-a putut trimite mesajul. Te rugam sa incerci din nou.",
                                variant: "error"
                            });
                            return _ctx.abrupt("return", null);
                        case 7:
                            _this1.setState(_objectSpread({
                                vote: type
                            }, values ? {
                                formIsActive: false
                            } : null));
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(type) {
                return _ref.apply(this, arguments);
            };
        }());
        return _this;
    }
    _createClass(Feedback, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props.articleSlug !== prevProps.articleSlug) {
                    this.setState({
                        vote: null,
                        formIsActive: true
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        (!this.state.vote || this.state.vote === "downvote") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center px-4 py-3 text-sm bg-newGray-light",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mr-2 -tracking-0.29",
                                    children: "Ti-a fost de ajutor acest raspuns?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "ml-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        onClick: function() {
                                            return !_this.state.vote ? _this.voteHandler("upvote") : "";
                                        },
                                        className: "py-1 px-2 text-white bg-bleu sm:hover:bg-bleu-hover sm:focus:bg-bleu-active rounded outline-none",
                                        children: "Da"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "ml-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return !_this.state.vote ? _this.voteHandler("downvote") : "";
                                        },
                                        type: "button",
                                        className: "py-1 px-2 text-white bg-bleu sm:hover:bg-bleu-hover sm:focus:bg-bleu-active rounded outline-none",
                                        children: "Nu"
                                    })
                                })
                            ]
                        }),
                        this.state.vote && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "p-5 text-sm\n            ".concat(this.state.vote === "downvote" ? "border-gray-1100 border-t" : "", "\n          "),
                            children: this.state.vote === "downvote" && this.state.formIsActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "block mb-3 text-black",
                                        children: "Cum putem imbunatati acest raspuns?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Support_FeedbackForm, {
                                        submitFeedback: function(values) {
                                            return _this.voteHandler("downvote", values);
                                        }
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "-traking-0.29",
                                children: "Iti multumim pentru feedback."
                            })
                        })
                    ]
                }));
            }
        }
    ]);
    return Feedback;
}(react.Component);
/* harmony default export */ var Support_Feedback = ((0,es/* connect */.$j)(null, {
    addAlert: actions/* addAlert */.V_
})(Feedback));


/***/ }),

/***/ 32463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66688);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var _components_Form_InputText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58833);






var handleFormSubmit = function(param) {
    var search = param.search;
    // merge cu gateway-ul de live. Pe stage apar erori CORS
    next_router__WEBPACK_IMPORTED_MODULE_3__["default"].push("/suport-clienti/cauta/?qs=".concat(search));
};
var SupportSearchForm = function(param1) {
    var router = param1.router, _label = param1.label, label = _label === void 0 ? null : _label, _hasTitle = param1.hasTitle, hasTitle = _hasTitle === void 0 ? true : _hasTitle;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: "\n      is-hidden-in-mobile-app-contact-page\n      py-4\n      lg:py-0\n      ".concat(hasTitle == true && label ? "lg:mt-12" : "mt-4 lg:mt-0", "\n    "),
            children: [
                hasTitle && label,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "md:w-524px mx-auto",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Form */ .l0, {
                        onSubmit: handleFormSubmit,
                        initialValues: {
                            search: router.query.qs || ""
                        },
                        render: function(param) {
                            var handleSubmit = param.handleSubmit, submitting = param.submitting;
                            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
                                onSubmit: handleSubmit,
                                className: "w-full mt-4",
                                autoComplete: "off",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                                            name: "search",
                                            component: _components_Form_InputText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                                            placeholder: "Cauta in articolele de suport",
                                            minLength: "3",
                                            maxLength: "50",
                                            required: true,
                                            className: "\n                        SearchInputComponent\n                        w-full mb-0 text-black border border-gray-light p-3 pl-5\n                        rounded-bl-lg\n                        rounded-tr-lg bg-white\n                        focus:border-black outline-none\n                      "
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            type: "submit",
                                            title: "Cauta",
                                            disabled: submitting,
                                            className: "v-align-middle-abs right-3 pl-3 ie-top",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                width: "17",
                                                height: "17",
                                                viewBox: "0 0 17 17",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        clipRule: "evenodd",
                                                        d: "M11.4834 13.0863L12.8167 11.7529L15.8499 14.7861C16.2181 15.1543 16.2181 15.7513 15.8499 16.1195C15.4818 16.4877 14.8848 16.4877 14.5166 16.1195L11.4834 13.0863Z",
                                                        fill: "#ADADAD"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                        cx: "7.5",
                                                        cy: "7.5",
                                                        r: "6.75",
                                                        stroke: "#ADADAD",
                                                        strokeWidth: "1.5"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }));
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,next_router__WEBPACK_IMPORTED_MODULE_3__.withRouter)(SupportSearchForm));


/***/ }),

/***/ 23751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11752);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73510);





var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), settings = ref.publicRuntimeConfig.settings;
var TopArticles = function(param) {
    var items = param.items;
    if (!items || !items.length) {
        return null;
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Heading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: "Cele mai citite articole de suport",
                as: "h2",
                display: "h1",
                classesProp: "mb-1 lg:mb-2 -tracking-0.5 lg:-tracking-0.67 leading-30 lg:leading-normal"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-wrap -ml-3 overflow-hidden",
                children: items.map(function(item) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                        href: "".concat(settings.baseUrl, "/suport-clienti/").concat(item.categories[0].slug, "/"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            className: "block w-auto ml-3 mt-3 py-10px px-5 rounded-bl-lg rounded-tr-lg bg-white border border-newsletterYellow-dark",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-newGray-mildDark text-sm font-medium leading-18.2 -tracking-0.29",
                                    style: {
                                        marginBottom: "6px"
                                    },
                                    children: item.categories[0].name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "leading-20.8",
                                    children: item.title
                                })
                            ]
                        })
                    }, item.title);
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (TopArticles);


/***/ }),

/***/ 89229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35035);
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__);

// JSON-LD blocks are injected with dangerouslySetInnerHTML, so a "<" coming
// from product data (a "</script>" inside a product name or description) would
// close the script element early and make the whole block unparsable for
// crawlers, besides letting the markup run in the browser. These characters
// are only ever part of JSON string values, where the escaped form is
// equivalent, so escaping them keeps the JSON valid and the page safe.
var HTML_UNSAFE_ESCAPES = {
    "<": "\\u003c",
    ">": "\\u003e",
    "&": "\\u0026"
};
var serializeSchema = function(schema) {
    return fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default()(schema).replace(/[<>&]/g, function(character) {
        return HTML_UNSAFE_ESCAPES[character];
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (serializeSchema);


/***/ }),

/***/ 16855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ suport_clienti; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./store/support/actions.js
var actions = __webpack_require__(3697);
// EXTERNAL MODULE: ./components/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(94512);
// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./containers/Support/TopArticles.js
var TopArticles = __webpack_require__(23751);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./components/Icons/ArrowDown.js
var ArrowDown = __webpack_require__(26206);
;// CONCATENATED MODULE: ./containers/Support/Categories.js





function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, settings = _publicRuntimeConfig.settings, _content = _publicRuntimeConfig.content, _supportMenuLinks = _content.supportMenuLinks, stores = _supportMenuLinks.stores, contact = _supportMenuLinks.contact;
var Categories = function(param) {
    var items = param.items;
    var ref1 = (0,react.useState)([]), activeDropdowns = ref1[0], setActiveDropdowns = ref1[1];
    if (!items || !items.length) {
        return null;
    }
    // THIS IS A TEMP HACK BECAUSE REASONS
    // REMOVE WHEN https://axsysro.atlassian.net/browse/ECOMDEV-2495 IS DONE
    // PAY ATTENTION TO ROUTE KEY, IT IS TEMP
    var tempItems = _toConsumableArray(items.slice(0, 3)).concat([
        {
            name: "Sesizari si reclamatii",
            children: [
                {
                    name: "Formular contact",
                    children: [],
                    slug: "formular-contact",
                    route: "contact"
                },
                {
                    name: "Returneaza produse",
                    children: [],
                    route: "cont/retururi",
                    slug: "returneaza-produse"
                }, 
            ],
            slug: "sesizari-si-reclamatii"
        }, 
    ], _toConsumableArray(items.slice(3)));
    var renderCategory = function(item, i) {
        var hiddenOnDesktop = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var articles = item.children || item.links;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "\n        md:px-10 md:mt-12 md:pt-1\n      border-gray-1100 border md:border-0\n        ".concat(i == items.length + 1 ? "rounded-bl-lg" : "", "\n        ").concat(i == 0 ? "border-t rounded-tr-lg" : "border-t-0", "\n        ").concat(hiddenOnDesktop ? "md:hidden" : "", "\n      "),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "\n          flex justify-between items-center cursor-pointer md:pointer-events-none px-4 py-2 md:p-0\n          border-l-4 md:border-0\n          ".concat(activeDropdowns.includes(i) ? "border-primary" : "border-transparent", "\n          "),
                    onClick: function() {
                        if (activeDropdowns.includes(i)) {
                            var active = activeDropdowns.filter(function(a) {
                                return a != i;
                            });
                            setActiveDropdowns(_toConsumableArray(active));
                        } else {
                            setActiveDropdowns(_toConsumableArray(activeDropdowns).concat([
                                i
                            ]));
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "\n            md:mb-3 font-normal text-sm md:text-3xl -lg:tracking-0.67 -tracking-0.39\n            ".concat(activeDropdowns.includes(i) ? "text-newGray-mildDark md:text-black" : "", "\n          "),
                            children: item.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "duration-75 ".concat(activeDropdowns.includes(i) ? "rotate-180" : "", "  ml-2 md:hidden"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "\n          text-sm md:block px-10 pt-3 pb-4 md:p-0 border-gray-1100 border-t md:border-t-0\n          ".concat(activeDropdowns.includes(i) ? "" : "hidden", "\n        "),
                    children: articles.map(function(article) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            className: "pt-1 pb-1",
                            children: article.route ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "".concat(settings.baseUrl, "/").concat(article.route, "/"),
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "inline-block text-black hover:text-newGray-mildDark leading-24px -tracking-0.29",
                                    children: article.name
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: item.children ? "".concat(settings.baseUrl, "/suport-clienti/").concat(article.slug, "/") : "".concat(settings.baseUrl).concat(article.slug),
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "inline-block text-black hover:text-newGray-mildDark leading-24px -tracking-0.29",
                                    children: article.name
                                })
                            })
                        }, article.slug);
                    })
                })
            ]
        }, item.name));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mt-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:flex md:flex-wrap md:justify-center",
                children: [
                    tempItems.map(function(item, i) {
                        return renderCategory(item, i);
                    }),
                    renderCategory(stores, tempItems.length, true),
                    renderCategory(contact, tempItems.length + 1, true)
                ]
            })
        })
    }));
};
/* harmony default export */ var Support_Categories = (Categories);

// EXTERNAL MODULE: ./node_modules/lodash/chunk.js
var chunk = __webpack_require__(8400);
var chunk_default = /*#__PURE__*/__webpack_require__.n(chunk);
// EXTERNAL MODULE: ./containers/Support/Feedback.js + 1 modules
var Feedback = __webpack_require__(21260);
// EXTERNAL MODULE: ./components/ContentEditorView/HtmlEmbed.js
var HtmlEmbed = __webpack_require__(96936);
;// CONCATENATED MODULE: ./containers/Support/TopFaqCard.js







function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var TopFaqCard_ref = (0,config["default"])(), TopFaqCard_settings = TopFaqCard_ref.publicRuntimeConfig.settings;
var TopFaqCard = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(TopFaqCard, Component1);
    var _super = _createSuper(TopFaqCard);
    function TopFaqCard() {
        _classCallCheck(this, TopFaqCard);
        var _this;
        _this = _super.apply(this, arguments);
        _defineProperty(_assertThisInitialized(_this), "state", {
            isActive: false
        });
        _defineProperty(_assertThisInitialized(_this), "toggleDisplay", function() {
            _this.setState(function(prevState) {
                return {
                    isActive: !prevState.isActive
                };
            });
        });
        return _this;
    }
    _createClass(TopFaqCard, [
        {
            key: "render",
            value: function render() {
                var isActive = this.state.isActive;
                var item1 = this.props.item;
                if (!item1) {
                    return null;
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                    className: "\n        mt-2 w-full border rounded-tr-lg rounded-bl-lg overflow-hidden border-gray-1100\n      ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex py-10px px-5 cursor-pointer",
                            onClick: this.toggleDisplay,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pr-4 grow",
                                    children: [
                                        item1.categories && item1.categories.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-newGray-mildDark text-sm font-medium leading-18.2 -tracking-0.29",
                                            style: {
                                                marginBottom: "6px"
                                            },
                                            children: item1.categories[0].name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: item1.title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "self-center duration-100 ".concat(isActive ? "rotate-180" : ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            hidden: !isActive,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "py-3 px-4 lg:px-10 border-t border-gray-1100",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed/* default */.Z, {
                                            className: "text-sm leading-20 -tracking-0.29",
                                            html: item1.content
                                        }),
                                        item1.tags && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pt-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-wrap -ml-2",
                                                children: item1.tags.map(function(item) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                                        href: "".concat(TopFaqCard_settings.baseUrl, "/suport-clienti/cauta/?ts=").concat(encodeURIComponent(item.title)),
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "ml-2 mb-2 px-2 py-1 rounded-tr-lg rounded-bl-lg text-13px leading-none -tracking-0.18 bg-newsletterYellow-light hover:bg-newsletterYellow-hover",
                                                            children: item.title
                                                        })
                                                    }, item.slug);
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "border-t border-gray-1100",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Feedback/* default */.Z, {
                                        articleSlug: item1.slug
                                    })
                                })
                            ]
                        })
                    ]
                }));
            }
        }
    ]);
    return TopFaqCard;
}(react.Component);
/* harmony default export */ var Support_TopFaqCard = (TopFaqCard);

;// CONCATENATED MODULE: ./containers/Support/TopFaqs.js





var TopFaqs = function(param) {
    var items = param.items;
    if (!items || !items.length) {
        return null;
    }
    var chunkedItems = chunk_default()(items, Math.ceil(items.length / 2));
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                title: "Cele mai votate intrebari frecvente",
                as: "h2",
                display: "h1",
                classesProp: "mb-3 lg:mb-2 -tracking-0.5 lg:-tracking-0.67 leading-30 lg:leading-normal"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "overflow-hidden -ml-3 flex flex-wrap",
                children: chunkedItems.map(function(chunk, i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        className: "w-full md:w-1/2 pl-3",
                        children: chunk.map(function(item) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: "flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Support_TopFaqCard, {
                                    item: item,
                                    hasDropdown: true
                                })
                            }, item.title);
                        })
                    }, i);
                })
            })
        ]
    }));
};
/* harmony default export */ var Support_TopFaqs = (TopFaqs);

// EXTERNAL MODULE: ./containers/Support/SearchForm.js
var SearchForm = __webpack_require__(32463);
;// CONCATENATED MODULE: ./components/Icons/PhoneCall.js


var PhoneCall = function(param) {
    var _width = param.width, width = _width === void 0 ? "54px" : _width, _height = param.height, height = _height === void 0 ? "54px" : _height;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        className: "fill-current",
        width: width,
        height: height,
        viewBox: "0 0 150 150",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M36.0831 75.8649C36.0831 75.8649 14.8444 68.6101 18.4587 45.9872C20.4868 35.1596 33.8358 16.2042 61.9515 28.4684C68.0484 30.9149 74.736 28.8679 85.2354 21.715C93.8753 15.6072 107.535 12.3617 120.144 30.4838C124.708 37.0506 144.818 70.0349 116.955 87.3816C114.759 127.492 39.3583 136.55 36.0831 75.8649",
                fill: "#FFE29B"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M31.6261 99.6406C30.9715 99.6406 30.4403 99.1077 30.4403 98.4539V52.2125C30.4403 51.5578 30.9715 51.0258 31.6261 51.0258H110.029C110.684 51.0258 111.216 51.5578 111.216 52.2125V98.4539C111.216 99.1077 110.684 99.6406 110.029 99.6406H31.6261Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M110.03 50.3867H31.6264C30.6174 50.3867 29.7994 51.2037 29.7994 52.2119V98.4542C29.7994 99.4624 30.6174 100.279 31.6264 100.279H110.03C111.037 100.279 111.855 99.4624 111.855 98.4542V52.2119C111.855 51.2037 111.037 50.3867 110.03 50.3867M110.03 51.6645C110.331 51.6645 110.577 51.9098 110.577 52.2119V98.4542C110.577 98.7563 110.331 99.0016 110.03 99.0016H31.6264C31.3243 99.0016 31.0781 98.7563 31.0781 98.4542V52.2119C31.0781 51.9098 31.3243 51.6645 31.6264 51.6645H110.03",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M37.5757 93.9278C36.921 93.9278 36.3899 93.3948 36.3899 92.741V46.4997C36.3899 45.845 36.921 45.312 37.5757 45.312H115.979C116.634 45.312 117.166 45.845 117.166 46.4997V92.741C117.166 93.3948 116.634 93.9278 115.979 93.9278H37.5757Z",
                fill: "#FFCB05"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M115.979 44.6736H37.576C36.5669 44.6736 35.749 45.4915 35.749 46.4997V92.7411C35.749 93.7493 36.5669 94.5672 37.576 94.5672H115.979C116.987 94.5672 117.805 93.7493 117.805 92.7411V46.4997C117.805 45.4915 116.987 44.6736 115.979 44.6736M115.979 45.9514C116.28 45.9514 116.527 46.1975 116.527 46.4996V92.741C116.527 93.0431 116.28 93.2884 115.979 93.2884H37.576C37.2739 93.2884 37.0277 93.0431 37.0277 92.741V46.4996C37.0277 46.1975 37.2739 45.9514 37.576 45.9514H115.979",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.0043 19.0657C22.0043 19.0657 22.0043 19.145 21.8474 19.2235C21.8474 19.2235 17.9968 20.4887 15.1679 23.2544C12.4166 26.0202 11.1595 29.9718 11.1595 29.9718C11.1595 30.1305 11.0026 30.1305 11.0026 30.1305C11.0026 30.1305 10.9241 30.1305 10.8448 29.9718C10.8448 29.9718 9.5868 26.0202 6.83728 23.2544C4.08686 20.4887 0.156909 19.2235 0.156909 19.2235C0 19.2235 0 19.0657 0 19.0657C0 19.0657 0 18.9872 0.156909 18.9079C0.156909 18.9079 4.0075 17.6427 6.83728 14.8769C9.5868 12.1112 10.8448 8.15957 10.8448 8.15957C10.8448 8.00085 11.0026 8.00085 11.0026 8.00085C11.0026 8.00085 11.1595 8.00085 11.1595 8.15957C11.1595 8.15957 12.4166 12.1112 15.1679 14.8769C17.9183 17.6427 21.8474 18.9079 21.8474 18.9079C22.0043 18.9872 22.0043 19.0657 22.0043 19.0657",
                fill: "#FFCB05"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M104.253 28.1184C104.253 28.1184 104.253 28.15 104.191 28.1815C104.191 28.1815 102.651 28.6874 101.519 29.793C100.42 30.8986 99.917 32.4785 99.917 32.4785C99.917 32.5416 99.8539 32.5416 99.8539 32.5416C99.8539 32.5416 99.8232 32.5416 99.7917 32.4785C99.7917 32.4785 99.2885 30.8986 98.1883 29.793C97.09 28.6874 95.5182 28.1815 95.5182 28.1815C95.4559 28.1815 95.4559 28.1184 95.4559 28.1184C95.4559 28.1184 95.4559 28.0869 95.5182 28.0553C95.5182 28.0553 97.0575 27.5494 98.1883 26.4438C99.2885 25.3382 99.7917 23.7583 99.7917 23.7583C99.7917 23.6952 99.8539 23.6952 99.8539 23.6952C99.8539 23.6952 99.917 23.6952 99.917 23.7583C99.917 23.7583 100.42 25.3382 101.519 26.4438C102.619 27.5494 104.191 28.0553 104.191 28.0553C104.253 28.0869 104.253 28.1184 104.253 28.1184",
                fill: "#FFCB05"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M65.05 134.484C65.05 134.484 65.05 134.531 64.9562 134.578C64.9562 134.578 62.6557 135.333 60.9658 136.986C59.3219 138.638 58.5707 140.999 58.5707 140.999C58.5707 141.094 58.4778 141.094 58.4778 141.094C58.4778 141.094 58.43 141.094 58.3831 140.999C58.3831 140.999 57.6319 138.638 55.9889 136.986C54.3468 135.333 51.9985 134.578 51.9985 134.578C51.9056 134.578 51.9056 134.484 51.9056 134.484C51.9056 134.484 51.9056 134.437 51.9985 134.39C51.9985 134.39 54.299 133.634 55.9889 131.982C57.6319 130.329 58.3831 127.968 58.3831 127.968C58.3831 127.875 58.4778 127.875 58.4778 127.875C58.4778 127.875 58.5707 127.875 58.5707 127.968C58.5707 127.968 59.3219 130.329 60.9658 131.982C62.6088 133.634 64.9562 134.39 64.9562 134.39C65.05 134.437 65.05 134.484 65.05 134.484",
                fill: "#C00033"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.9894 83.2198C15.9894 83.2198 15.9894 83.2513 15.9272 83.2829C15.9272 83.2829 14.3897 83.7879 13.2606 84.8917C12.1623 85.9963 11.66 87.5736 11.66 87.5736C11.66 87.6367 11.5978 87.6367 11.5978 87.6367C11.5978 87.6367 11.5662 87.6367 11.5346 87.5736C11.5346 87.5736 11.0323 85.9963 9.93488 84.8917C8.83652 83.7879 7.26742 83.2829 7.26742 83.2829C7.2052 83.2829 7.2052 83.2198 7.2052 83.2198C7.2052 83.2198 7.2052 83.1882 7.26742 83.1566C7.26742 83.1566 8.80495 82.6516 9.93488 81.5479C11.0323 80.4432 11.5346 78.866 11.5346 78.866C11.5346 78.8029 11.5978 78.8029 11.5978 78.8029C11.5978 78.8029 11.66 78.8029 11.66 78.866C11.66 78.866 12.1623 80.4432 13.2606 81.5479C14.3581 82.6516 15.9272 83.1566 15.9272 83.1566C15.9894 83.1882 15.9894 83.2198 15.9894 83.2198",
                fill: "#C00033"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M149.999 65.8292C149.999 65.8292 149.999 65.8725 149.913 65.9166C149.913 65.9166 147.782 66.6164 146.216 68.1467C144.693 69.678 143.998 71.8648 143.998 71.8648C143.998 71.9532 143.911 71.9532 143.911 71.9532C143.911 71.9532 143.866 71.9532 143.823 71.8648C143.823 71.8648 143.128 69.678 141.605 68.1467C140.083 66.6164 137.908 65.9166 137.908 65.9166C137.821 65.9166 137.821 65.8292 137.821 65.8292C137.821 65.8292 137.821 65.785 137.908 65.7417C137.908 65.7417 140.039 65.041 141.605 63.5107C143.128 61.9795 143.823 59.7927 143.823 59.7927C143.823 59.7052 143.911 59.7052 143.911 59.7052C143.911 59.7052 143.998 59.7052 143.998 59.7927C143.998 59.7927 144.693 61.9795 146.216 63.5107C147.738 65.041 149.913 65.7417 149.913 65.7417C149.999 65.785 149.999 65.8292 149.999 65.8292",
                fill: "#C00033"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M82.2579 110.934C82.2579 110.934 82.2579 110.962 82.202 110.99C82.202 110.99 80.8376 111.439 79.8339 112.42C78.8582 113.4 78.4127 114.801 78.4127 114.801C78.4127 114.857 78.3577 114.857 78.3577 114.857C78.3577 114.857 78.3298 114.857 78.3018 114.801C78.3018 114.801 77.8563 113.4 76.8806 112.42C75.9058 111.439 74.5125 110.99 74.5125 110.99C74.4575 110.99 74.4575 110.934 74.4575 110.934C74.4575 110.934 74.4575 110.906 74.5125 110.879C74.5125 110.879 75.8778 110.43 76.8806 109.45C77.8563 108.469 78.3018 107.068 78.3018 107.068C78.3018 107.012 78.3577 107.012 78.3577 107.012C78.3577 107.012 78.4127 107.012 78.4127 107.068C78.4127 107.068 78.8582 108.469 79.8339 109.45C80.8096 110.43 82.202 110.879 82.202 110.879C82.2579 110.906 82.2579 110.934 82.2579 110.934",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M43.7817 87.9231C43.127 87.9231 42.595 87.3902 42.595 86.7364V40.495C42.595 39.8403 43.127 39.3074 43.7817 39.3074H122.184C122.839 39.3074 123.372 39.8403 123.372 40.495V86.7364C123.372 87.3902 122.839 87.9231 122.184 87.9231H43.7817Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M122.184 38.6688H43.782C42.7729 38.6688 41.9559 39.4867 41.9559 40.4949V86.7363C41.9559 87.7445 42.7729 88.5624 43.782 88.5624H122.184C123.194 88.5624 124.011 87.7445 124.011 86.7363V40.4949C124.011 39.4867 123.194 38.6688 122.184 38.6688M122.184 39.9466C122.487 39.9466 122.732 40.1928 122.732 40.4949V86.7362C122.732 87.0383 122.487 87.2836 122.184 87.2836H43.782C43.4799 87.2836 43.2337 87.0383 43.2337 86.7362V40.4949C43.2337 40.1928 43.4799 39.9466 43.782 39.9466H122.184",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M43.7394 40.154L80.2858 77.1612C81.7701 78.6663 84.1986 78.669 85.6874 77.1666L122.548 39.9637",
                stroke: "black",
                strokeWidth: "1.417"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M43.3881 87.1685L67.0038 63.4977Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M43.3881 87.1685L67.0038 63.4977",
                stroke: "black",
                strokeWidth: "1.417"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M122.752 87.1685L98.8896 63.2516Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M122.752 87.1685L98.8896 63.2516",
                stroke: "black",
                strokeWidth: "1.417"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M58.3466 100.28H64.4318V97.9116H58.3466V100.28Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M97.4152 41.0364H103.5V38.6683H97.4152V41.0364Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M109.553 75.665L105.25 71.3617L106.924 69.688L111.227 73.9904L109.553 75.665Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var Icons_PhoneCall = (PhoneCall);

;// CONCATENATED MODULE: ./components/Icons/Map.js


var MapIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? "59px" : _width, _height = param.height, height = _height === void 0 ? "52px" : _height;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        className: "fill-current",
        width: width,
        height: height,
        viewBox: "0 0 150 150",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.6212 37.4859C33.5143 20.3838 51.4409 5.94306 63.5357 17.5998C70.2879 22.971 75.6027 28.8513 99.5886 27.6383C104.501 27.3545 128.498 26.624 132.628 52.0037C133.208 57.2958 132.882 70.9941 118.858 84.3652C114.591 88.3008 101.349 97.0303 112.329 112.063C118.729 120.785 111.359 133.477 87.216 130.652C76.1129 129.893 -12.8875 120.927 25.6212 37.4859",
                fill: "#FFE29B"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28.9394 13.1306C28.9394 13.1306 28.9394 13.2166 28.7664 13.3036C28.7664 13.3036 24.546 14.6896 21.4437 17.7227C18.4275 20.7548 17.0503 25.0869 17.0503 25.0869C17.0503 25.2609 16.8773 25.2609 16.8773 25.2609C16.8773 25.2609 16.7913 25.2609 16.7053 25.0869C16.7053 25.0869 15.3262 20.7548 12.3109 17.7227C9.2956 14.6896 4.98721 13.3036 4.98721 13.3036C4.81519 13.3036 4.81519 13.1306 4.81519 13.1306C4.81519 13.1306 4.81519 13.0436 4.98721 12.9576C4.98721 12.9576 9.20959 11.5705 12.3109 8.53845C15.3262 5.50636 16.7053 1.17325 16.7053 1.17325C16.7053 1.00024 16.8773 1.00024 16.8773 1.00024C16.8773 1.00024 17.0503 1.00024 17.0503 1.17325C17.0503 1.17325 18.4275 5.50636 21.4437 8.53845C24.459 11.5705 28.7664 12.9576 28.7664 12.9576C28.9394 13.0436 28.9394 13.1306 28.9394 13.1306",
                fill: "#FFCB05"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M91.7292 113.887C91.7292 113.887 91.7292 113.931 91.6432 113.974C91.6432 113.974 89.5295 114.668 87.9774 116.186C86.4677 117.704 85.7767 119.873 85.7767 119.873C85.7767 119.959 85.6917 119.959 85.6917 119.959C85.6917 119.959 85.6482 119.959 85.6057 119.873C85.6057 119.873 84.9146 117.704 83.405 116.186C81.8964 114.668 79.7392 113.974 79.7392 113.974C79.6532 113.974 79.6532 113.887 79.6532 113.887C79.6532 113.887 79.6532 113.844 79.7392 113.8C79.7392 113.8 81.8529 113.106 83.405 111.588C84.9146 110.07 85.6057 107.902 85.6057 107.902C85.6057 107.815 85.6917 107.815 85.6917 107.815C85.6917 107.815 85.7767 107.815 85.7767 107.902C85.7767 107.902 86.4677 110.07 87.9774 111.588C89.486 113.106 91.6432 113.8 91.6432 113.8C91.7292 113.844 91.7292 113.887 91.7292 113.887",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M55.4236 31.6086C55.4236 31.6086 55.4236 31.6491 55.3435 31.6897C55.3435 31.6897 53.3801 32.3343 51.9368 33.745C50.5339 35.1558 49.8923 37.1716 49.8923 37.1716C49.8923 37.2516 49.8122 37.2516 49.8122 37.2516C49.8122 37.2516 49.7717 37.2516 49.7311 37.1716C49.7311 37.1716 49.0905 35.1558 47.6877 33.745C46.2848 32.3343 44.2809 31.6897 44.2809 31.6897C44.1998 31.6897 44.1998 31.6086 44.1998 31.6086C44.1998 31.6086 44.1998 31.5681 44.2809 31.5275C44.2809 31.5275 46.2443 30.883 47.6877 29.4722C49.0905 28.0614 49.7311 26.0457 49.7311 26.0457C49.7311 25.9656 49.8122 25.9656 49.8122 25.9656C49.8122 25.9656 49.8923 25.9656 49.8923 26.0457C49.8923 26.0457 50.5339 28.0614 51.9368 29.4722C53.3396 30.883 55.3435 31.5275 55.3435 31.5275C55.4236 31.5681 55.4236 31.6086 55.4236 31.6086",
                fill: "#FFCB05"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.63061 91.0079C9.63061 91.0079 9.63061 91.0425 9.5624 91.0771C9.5624 91.0771 7.87681 91.6307 6.63906 92.8408C5.43492 94.0519 4.88426 95.7809 4.88426 95.7809C4.88426 95.8501 4.81506 95.8501 4.81506 95.8501C4.81506 95.8501 4.78144 95.8501 4.74684 95.7809C4.74684 95.7809 4.19618 94.0519 2.99205 92.8408C1.78791 91.6307 0.0687029 91.0771 0.0687029 91.0771C0.000488281 91.0771 0.000488281 91.0079 0.000488281 91.0079C0.000488281 91.0079 0.000488281 90.9733 0.0687029 90.9387C0.0687029 90.9387 1.7543 90.3851 2.99205 89.175C4.19618 87.9639 4.74684 86.2349 4.74684 86.2349C4.74684 86.1656 4.81506 86.1656 4.81506 86.1656C4.81506 86.1656 4.88426 86.1656 4.88426 86.2349C4.88426 86.2349 5.43492 87.9639 6.63906 89.175C7.8422 90.3851 9.5624 90.9387 9.5624 90.9387C9.63061 90.9733 9.63061 91.0079 9.63061 91.0079",
                fill: "#C00033"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M69.2391 141.011C69.2391 141.011 69.2391 141.062 69.1363 141.114C69.1363 141.114 66.6153 141.942 64.7626 143.753C62.9604 145.565 62.1368 148.154 62.1368 148.154C62.1368 148.256 62.034 148.256 62.034 148.256C62.034 148.256 61.9826 148.256 61.9312 148.154C61.9312 148.154 61.1077 145.565 59.3064 143.753C57.5052 141.942 54.9308 141.114 54.9308 141.114C54.829 141.114 54.829 141.011 54.829 141.011C54.829 141.011 54.829 140.958 54.9308 140.907C54.9308 140.907 57.4538 140.08 59.3064 138.267C61.1077 136.456 61.9312 133.868 61.9312 133.868C61.9312 133.764 62.034 133.764 62.034 133.764C62.034 133.764 62.1368 133.764 62.1368 133.868C62.1368 133.868 62.9604 136.456 64.7626 138.267C66.5629 140.08 69.1363 140.907 69.1363 140.907C69.2391 140.958 69.2391 141.011 69.2391 141.011",
                fill: "#C00033"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M150 55.2447C150 55.2447 150 55.2922 149.904 55.3406C149.904 55.3406 147.568 56.1078 145.851 57.7864C144.182 59.4641 143.419 61.8615 143.419 61.8615C143.419 61.9584 143.324 61.9584 143.324 61.9584C143.324 61.9584 143.276 61.9584 143.229 61.8615C143.229 61.8615 142.465 59.4641 140.797 57.7864C139.128 56.1078 136.744 55.3406 136.744 55.3406C136.648 55.3406 136.648 55.2447 136.648 55.2447C136.648 55.2447 136.648 55.1963 136.744 55.1488C136.744 55.1488 139.08 54.3816 140.797 52.703C142.465 51.0243 143.229 48.6269 143.229 48.6269C143.229 48.531 143.324 48.531 143.324 48.531C143.324 48.531 143.419 48.531 143.419 48.6269C143.419 48.6269 144.182 51.0243 145.851 52.703C147.52 54.3816 149.904 55.1488 149.904 55.1488C150 55.1963 150 55.2447 150 55.2447",
                fill: "#C00033"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M48.814 40.5813H54.3908V37.7183H48.814V40.5813Z",
                fill: "#FFE29B"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.5065 97.8564C24.7947 97.8564 24.1422 97.5291 23.7151 96.9607C23.289 96.3912 23.1595 95.6735 23.3582 94.9894L36.1816 51.1293C36.5493 49.8698 37.7218 48.991 39.0347 48.991H107.245C108.557 48.991 109.73 49.8698 110.098 51.1293L122.92 94.9894C123.12 95.6725 122.99 96.3912 122.564 96.9607C122.137 97.5291 121.483 97.8564 120.772 97.8564H25.5065Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M107.245 48.2898H39.0343C37.403 48.2898 35.9656 49.3664 35.5079 50.9334L22.6855 94.7934C22.1358 96.6737 23.5466 98.557 25.506 98.557H120.773C122.733 98.557 124.143 96.6737 123.594 94.7934L110.77 50.9334C110.314 49.3664 108.876 48.2898 107.245 48.2898M107.245 49.6906C108.248 49.6906 109.145 50.3639 109.426 51.3258L122.248 95.1858C122.385 95.6554 122.297 96.1487 122.003 96.5402C121.709 96.9307 121.261 97.1552 120.773 97.1552H25.5059C25.0175 97.1552 24.5697 96.9317 24.2761 96.5402C23.9824 96.1487 23.8935 95.6554 24.0309 95.1868L36.8523 51.3258C37.134 50.3639 38.0317 49.6906 39.0341 49.6906H107.245",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M85.6912 71.5184C76.5455 71.5184 67.9861 47.9359 67.9861 37.2223C67.9861 27.4587 75.9286 19.5151 85.6912 19.5151C95.4548 19.5151 103.397 27.4587 103.397 37.2223C103.397 47.9359 94.8369 71.5184 85.6912 71.5184",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M85.6912 18.8151C75.5263 18.8151 67.2852 27.0562 67.2852 37.2221C67.2852 47.3881 75.5263 72.2192 85.6912 72.2192C95.8562 72.2192 104.097 47.3881 104.097 37.2221C104.097 27.0562 95.8562 18.8151 85.6912 18.8151M85.6912 20.2159C95.0683 20.2159 102.696 27.8451 102.696 37.2221C102.696 42.3837 100.481 51.1072 97.4261 57.9623C93.788 66.1322 89.5102 70.8183 85.6912 70.8183C81.8722 70.8183 77.5944 66.1322 73.9563 57.9623C70.9015 51.1072 68.686 42.3837 68.686 37.2221C68.686 27.8451 76.3142 20.2159 85.6912 20.2159",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M85.6912 47.1356C80.7481 47.1356 76.7274 43.1139 76.7274 38.1708C76.7274 33.2278 80.7481 29.2061 85.6912 29.2061C90.6343 29.2061 94.655 33.2278 94.655 38.1708C94.655 43.1139 90.6343 47.1356 85.6912 47.1356",
                fill: "#FFCB05"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M85.6912 28.5059C80.3537 28.5059 76.0265 32.833 76.0265 38.1706C76.0265 43.5091 80.3537 47.8363 85.6912 47.8363C91.0288 47.8363 95.3559 43.5091 95.3559 38.1706C95.3559 32.833 91.0288 28.5059 85.6912 28.5059M85.6911 29.9067C90.2476 29.9067 93.954 33.614 93.954 38.1705C93.954 42.7281 90.2476 46.4354 85.6911 46.4354C81.1346 46.4354 77.4282 42.7281 77.4282 38.1705C77.4282 33.614 81.1346 29.9067 85.6911 29.9067",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M48.0873 81.2516L37.6119 87.9969Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M48.0873 81.2516L37.6119 87.9969",
                stroke: "black",
                strokeWidth: "1.417",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M39.3374 81.2516L49.8128 87.9969Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M39.3374 81.2516L49.8128 87.9969",
                stroke: "black",
                strokeWidth: "1.417",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M41.722 49.6196L103.729 97.4104Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M41.722 49.6196L103.729 97.4104",
                stroke: "black",
                strokeWidth: "1.417"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M62.7736 97.6299L113.899 64.873Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M62.7736 97.6299L113.899 64.873",
                stroke: "black",
                strokeWidth: "1.417"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M39.514 98.6952H46.1852V96.0991H39.514V98.6952Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M55.424 50.8856H62.0951V48.2905H55.424V50.8856Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var Map = (MapIcon);

;// CONCATENATED MODULE: ./components/Icons/FileText.js


var FileText = function(param) {
    var _width = param.width, width = _width === void 0 ? "44px" : _width, _height = param.height, height = _height === void 0 ? "54px" : _height;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        className: "fill-current",
        width: width,
        height: height,
        viewBox: "0 0 150 150",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M120.507 111.115C111.995 127.133 92.7519 139.693 81.5466 128.024C75.2494 122.603 72.8644 114.1 47.2242 117.02C36.8749 118.017 18.4355 117.364 16.3371 92.3413C15.9762 87.2266 16.8008 74.0571 30.7948 61.7112C35.0469 58.0827 48.1164 50.1755 38.1098 35.3008C32.2753 26.6681 39.8407 14.7297 62.9692 18.3458C73.6261 19.4912 162.233 32.6026 120.507 111.115",
                fill: "#FFE29B"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M48.0149 107.443C46.8105 107.443 45.8308 106.463 45.8308 105.259V37.0284C45.8308 35.8249 46.8105 34.8452 48.0149 34.8452H87.3292C87.9071 34.8452 88.4736 35.0794 88.883 35.4879L105.537 52.1421C105.952 52.5581 106.181 53.1104 106.181 53.6969V105.259C106.181 106.463 105.201 107.443 103.997 107.443H48.0149Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M87.3292 34.1702H48.015C46.4364 34.1702 45.1567 35.4498 45.1567 37.0284V105.259C45.1567 106.838 46.4364 108.117 48.015 108.117H103.998C105.576 108.117 106.856 106.838 106.856 105.259V53.6968C106.856 52.9342 106.552 52.2039 106.014 51.6651L89.361 35.0109C88.8211 34.4729 88.0909 34.1702 87.3292 34.1702M87.3292 35.5193C87.7358 35.5193 88.1185 35.6773 88.406 35.9658L105.06 52.62C105.348 52.9075 105.506 53.2903 105.506 53.6968V105.259C105.506 106.091 104.829 106.768 103.998 106.768H48.015C47.1828 106.768 46.5059 106.091 46.5059 105.259V37.0283C46.5059 36.1962 47.1828 35.5193 48.015 35.5193H87.3292",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.4461 17.6818C25.4461 17.6818 25.4461 17.7656 25.2795 17.8484C25.2795 17.8484 21.214 19.1842 18.2273 22.1043C15.3224 25.0244 13.9961 29.1965 13.9961 29.1965C13.9961 29.3641 13.8295 29.3641 13.8295 29.3641C13.8295 29.3641 13.7467 29.3641 13.6638 29.1965C13.6638 29.1965 12.3356 25.0244 9.43173 22.1043C6.52782 19.1842 2.37856 17.8484 2.37856 17.8484C2.21289 17.8484 2.21289 17.6818 2.21289 17.6818C2.21289 17.6818 2.21289 17.599 2.37856 17.5152C2.37856 17.5152 6.44499 16.1803 9.43173 13.2593C12.3356 10.3392 13.6638 6.16708 13.6638 6.16708C13.6638 5.99951 13.8295 5.99951 13.8295 5.99951C13.8295 5.99951 13.9961 5.99951 13.9961 6.16708C13.9961 6.16708 15.3224 10.3392 18.2273 13.2593C21.1312 16.1803 25.2795 17.5152 25.2795 17.5152C25.4461 17.599 25.4461 17.6818 25.4461 17.6818",
                fill: "#FFCB05"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M100.187 119.067C100.187 119.067 100.187 119.107 100.109 119.146C100.109 119.146 98.1858 119.778 96.7729 121.159C95.4 122.541 94.7716 124.513 94.7716 124.513C94.7716 124.592 94.6926 124.592 94.6926 124.592C94.6926 124.592 94.6535 124.592 94.6136 124.513C94.6136 124.513 93.9861 122.541 92.6132 121.159C91.2393 119.778 89.277 119.146 89.277 119.146C89.198 119.146 89.198 119.067 89.198 119.067C89.198 119.067 89.198 119.027 89.277 118.988C89.277 118.988 91.2003 118.357 92.6132 116.975C93.9861 115.594 94.6136 113.62 94.6136 113.62C94.6136 113.541 94.6926 113.541 94.6926 113.541C94.6926 113.541 94.7716 113.541 94.7716 113.62C94.7716 113.62 95.4 115.594 96.7729 116.975C98.1459 118.357 100.109 118.988 100.109 118.988C100.187 119.027 100.187 119.067 100.187 119.067",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M38.7915 90.9742C38.7915 90.9742 38.7915 91.0065 38.7267 91.0399C38.7267 91.0399 37.1339 91.5626 35.9618 92.707C34.8241 93.8514 34.3042 95.4871 34.3042 95.4871C34.3042 95.5528 34.2395 95.5528 34.2395 95.5528C34.2395 95.5528 34.2071 95.5528 34.1738 95.4871C34.1738 95.4871 33.6539 93.8514 32.5152 92.707C31.3775 91.5626 29.7513 91.0399 29.7513 91.0399C29.6865 91.0399 29.6865 90.9742 29.6865 90.9742C29.6865 90.9742 29.6865 90.9418 29.7513 90.9085C29.7513 90.9085 31.3451 90.3858 32.5152 89.2413C33.6539 88.096 34.1738 86.4612 34.1738 86.4612C34.1738 86.3955 34.2395 86.3955 34.2395 86.3955C34.2395 86.3955 34.3042 86.3955 34.3042 86.4612C34.3042 86.4612 34.8241 88.096 35.9618 89.2413C37.1015 90.3858 38.7267 90.9085 38.7267 90.9085C38.7915 90.9418 38.7915 90.9742 38.7915 90.9742",
                fill: "#FFCB05"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M63.0543 137.876C63.0543 137.876 63.0543 137.926 62.9553 137.975C62.9553 137.975 60.5265 138.773 58.7423 140.518C57.0066 142.263 56.2135 144.755 56.2135 144.755C56.2135 144.854 56.1145 144.854 56.1145 144.854C56.1145 144.854 56.065 144.854 56.0154 144.755C56.0154 144.755 55.2223 142.263 53.4876 140.518C51.7529 138.773 49.2746 137.975 49.2746 137.975C49.1755 137.975 49.1755 137.876 49.1755 137.876C49.1755 137.876 49.1755 137.827 49.2746 137.776C49.2746 137.776 51.7034 136.979 53.4876 135.234C55.2223 133.49 56.0154 130.997 56.0154 130.997C56.0154 130.897 56.1145 130.897 56.1145 130.897C56.1145 130.897 56.2135 130.897 56.2135 130.997C56.2135 130.997 57.0066 133.49 58.7423 135.234C60.477 136.979 62.9553 137.776 62.9553 137.776C63.0543 137.827 63.0543 137.876 63.0543 137.876",
                fill: "#C00033"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.27539 91.5046C9.27539 91.5046 9.27539 91.5379 9.20874 91.5712C9.20874 91.5712 7.58636 92.1044 6.39337 93.2698C5.23371 94.4361 4.70339 96.1013 4.70339 96.1013C4.70339 96.168 4.63769 96.168 4.63769 96.168C4.63769 96.168 4.60437 96.168 4.572 96.1013C4.572 96.1013 4.04168 94.4361 2.88202 93.2698C1.72235 92.1044 0.0656951 91.5712 0.0656951 91.5712C0 91.5712 0 91.5046 0 91.5046C0 91.5046 0 91.4713 0.0656951 91.4379C0.0656951 91.4379 1.68903 90.9048 2.88202 89.7394C4.04168 88.5731 4.572 86.9078 4.572 86.9078C4.572 86.8412 4.63769 86.8412 4.63769 86.8412C4.63769 86.8412 4.70339 86.8412 4.70339 86.9078C4.70339 86.9078 5.23371 88.5731 6.39337 89.7394C7.55208 90.9048 9.20874 91.4379 9.20874 91.4379C9.27539 91.4713 9.27539 91.5046 9.27539 91.5046",
                fill: "#C00033"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M150 86.3955C150 86.3955 150 86.4422 149.907 86.4879C149.907 86.4879 147.658 87.2267 146.005 88.8434C144.397 90.4601 143.663 92.7689 143.663 92.7689C143.663 92.8613 143.57 92.8613 143.57 92.8613C143.57 92.8613 143.524 92.8613 143.478 92.7689C143.478 92.7689 142.744 90.4601 141.137 88.8434C139.529 87.2267 137.233 86.4879 137.233 86.4879C137.142 86.4879 137.142 86.3955 137.142 86.3955C137.142 86.3955 137.142 86.3498 137.233 86.3032C137.233 86.3032 139.483 85.5644 141.137 83.9477C142.744 82.332 143.478 80.0231 143.478 80.0231C143.478 79.9298 143.57 79.9298 143.57 79.9298C143.57 79.9298 143.663 79.9298 143.663 80.0231C143.663 80.0231 144.397 82.332 146.005 83.9477C147.612 85.5644 149.907 86.3032 149.907 86.3032C150 86.3498 150 86.3955 150 86.3955",
                fill: "#C00033"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M55.0376 100.812C53.7951 100.812 52.7859 99.8007 52.7859 98.5592V30.3696C52.7859 29.1804 53.7523 28.214 54.9405 28.214H92.7228C94.3166 28.214 95.8152 28.8338 96.9416 29.9601L111.389 44.4074C112.515 45.5346 113.136 47.0333 113.136 48.6261V98.6563C113.136 99.8445 112.169 100.812 110.98 100.812H55.0376Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M92.7228 27.5391H54.9414C53.3781 27.5391 52.1108 28.8063 52.1108 30.3697V98.5593C52.1108 100.176 53.4209 101.486 55.0376 101.486H110.98C112.543 101.486 113.81 100.219 113.81 98.6564V48.6262C113.81 46.8648 113.111 45.1758 111.865 43.9305L97.4186 29.4833C96.1732 28.2379 94.4842 27.5391 92.7228 27.5391M92.7228 28.8881C94.1358 28.8881 95.4649 29.4384 96.4646 30.4372L110.912 44.8854C111.91 45.8841 112.46 47.2132 112.46 48.6262V98.6563C112.46 99.4723 111.796 100.137 110.98 100.137H55.0377C54.1684 100.137 53.46 99.4294 53.46 98.5592V30.3696C53.46 29.5527 54.1246 28.8881 54.9415 28.8881H92.7228",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M92.4941 28.001V43.7821C92.4941 46.228 94.4774 48.2113 96.9233 48.2113H113.006",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M92.4941 28.001V43.7821C92.4941 46.228 94.4774 48.2113 96.9233 48.2113H113.006",
                stroke: "black",
                strokeWidth: "1.417"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M67.335 59.8999H103.02",
                stroke: "black",
                strokeWidth: "1.417",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M67.335 68.391H103.02",
                stroke: "black",
                strokeWidth: "1.417",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M67.335 76.8829H103.02",
                stroke: "black",
                strokeWidth: "1.417",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M67.335 85.374H84.7594",
                stroke: "black",
                strokeWidth: "1.417",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M67.335 44.6289H78.1299",
                stroke: "black",
                strokeWidth: "1.417",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M97.0463 47.5838H112.372C112.212 46.6165 111.769 45.7224 111.061 45.015L96.2999 30.2527C95.4468 29.4015 94.3262 28.9283 93.1284 28.8835V43.6659C93.1284 45.83 94.8831 47.5838 97.0463 47.5838",
                fill: "#FFCB05"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M60.5508 101.753H66.9756V99.2527H60.5508V101.753Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M87.7878 69.6415H94.2136V67.1422H87.7878V69.6415Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M87.7878 108.118H94.2136V105.618H87.7878V108.118Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var Icons_FileText = (FileText);

;// CONCATENATED MODULE: ./containers/Support/Footer.js







var Col = function(param) {
    var icon = param.icon, title = param.title, children = param.children, _classesProp = param.classesProp, classesProp = _classesProp === void 0 ? "" : _classesProp, _isLast = param.isLast, isLast = _isLast === void 0 ? false : _isLast;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: "\n    flex md:w-1/3 md:ml-4 relative\n    lg:mt-4 pt-10 md:pt-12 px-6\n    ".concat(isLast ? "" : "pb-16 md:pb-0", "\n    ").concat(classesProp, "\n  "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full text-center text-sm leading-24px -tracking-0.29",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center text-white",
                    children: icon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-26px leading-33.8 -tracking-0.54 mt-6",
                    children: title
                }),
                children
            ]
        })
    });
};
var ColItem = function(param) {
    var item = param.item;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
        className: "mt-1",
        children: item.slug ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: "".concat(Footer_settings.baseUrl).concat(item.slug),
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "text-black hover:text-secondary",
                children: item.name
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "text-black hover:text-secondary",
            href: item.link,
            target: "_blank",
            rel: "noopener noreferrer",
            children: item.name
        })
    });
};
var Footer_ref = (0,config["default"])(), Footer_publicRuntimeConfig = Footer_ref.publicRuntimeConfig, Footer_settings = Footer_publicRuntimeConfig.settings, content = Footer_publicRuntimeConfig.content;
var SupportFooter = function() {
    var _supportMenuLinks = content.supportMenuLinks, info = _supportMenuLinks.info, contact = _supportMenuLinks.contact;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "pt-6 md:flex md:-ml-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col, {
                title: contact.name,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PhoneCall, {
                    width: "150px",
                    height: "150px"
                }),
                classesProp: "custom-border md-custom-border-right custom-border-bottom",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "m-0 mt-4 p-0",
                    children: contact.links.map(function(item) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ColItem, {
                            item: item
                        }, item.slug);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col, {
                title: "Reteaua de magazine",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Map, {
                    width: "150px",
                    height: "150px"
                }),
                classesProp: "custom-border md-custom-border-right custom-border-bottom",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-4 mt-4",
                        children: "Vezi adresele magazinelor, datele de contact si orarul de functionare."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "".concat(Footer_settings.baseUrl, "/magazine/"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            title: "Lista magazinelor ".concat(content.websiteTitle),
                            className: "text-red-brand hover:text-bleu-hover underline",
                            children: "Lista magazinelor ".concat(content.websiteTitle)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col, {
                title: info.name,
                isLast: true,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_FileText, {
                    width: "150px",
                    height: "150px"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "m-0 mt-4 p-0",
                    children: info.links.map(function(item) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ColItem, {
                            item: item
                        }, item.slug || item.link);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                suppressHydrationWarning: true,
                children: "\n          .custom-border:after {\n            content: '';\n            display: inline-block;\n            position: absolute;\n            background-color: #D8D8D8;\n          }\n\n          .custom-border-bottom:after {\n            bottom: 0;\n            right: 20%;\n            left: 20%;\n            width: auto;\n            height: 1px;\n          }\n\n          @media (min-width: 768px) {\n            .custom-border-bottom:after {\n              display: none;\n            }\n          }\n        "
            })
        ]
    }));
};
/* harmony default export */ var Footer = (SupportFooter);

// EXTERNAL MODULE: ./components/FullWidthSection.js
var FullWidthSection = __webpack_require__(97995);
;// CONCATENATED MODULE: ./pages/suport-clienti/index.js














function suport_clienti_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function suport_clienti_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function suport_clienti_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function suport_clienti_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) suport_clienti_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) suport_clienti_defineProperties(Constructor, staticProps);
    return Constructor;
}
function suport_clienti_getPrototypeOf(o) {
    suport_clienti_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return suport_clienti_getPrototypeOf(o);
}
function suport_clienti_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) suport_clienti_setPrototypeOf(subClass, superClass);
}
function suport_clienti_possibleConstructorReturn(self, call) {
    if (call && (suport_clienti_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return suport_clienti_assertThisInitialized(self);
}
function suport_clienti_setPrototypeOf(o, p) {
    suport_clienti_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return suport_clienti_setPrototypeOf(o, p);
}
var suport_clienti_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function suport_clienti_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function suport_clienti_createSuper(Derived) {
    var hasNativeReflectConstruct = suport_clienti_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = suport_clienti_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = suport_clienti_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return suport_clienti_possibleConstructorReturn(this, result);
    };
}
var SupportIndexPage = /*#__PURE__*/ function(Component1) {
    "use strict";
    suport_clienti_inherits(SupportIndexPage, Component1);
    var _super = suport_clienti_createSuper(SupportIndexPage);
    function SupportIndexPage() {
        suport_clienti_classCallCheck(this, SupportIndexPage);
        return _super.apply(this, arguments);
    }
    suport_clienti_createClass(SupportIndexPage, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, supportCategories = _props.supportCategories, topSupportArticles = _props.topSupportArticles, topSupportFaqs = _props.topSupportFaqs;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: "Suport clienti"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                            className: "pt-3",
                            breadcrumbs: [
                                {
                                    id: 1,
                                    level: 99,
                                    name: "Suport clienti"
                                }, 
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm/* default */.Z, {
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                title: "Cu ce te putem ajuta?",
                                as: "h1",
                                display: "h1",
                                classesProp: "text-center -tracking-0.54 lg:-tracking-1"
                            })
                        }),
                        supportCategories && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "pt-6 pb-1 lg:py-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Support_Categories, {
                                items: supportCategories
                            })
                        }),
                        topSupportArticles && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "py-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSection/* default */.Z, {
                                backgroundColor: "bg-newsletterYellow",
                                padding: "pt-6 pb-10 lg:py-12 px-4 xs:px-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopArticles/* default */.Z, {
                                    items: topSupportArticles
                                })
                            })
                        }),
                        topSupportFaqs && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "py-1 lg:py-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Support_TopFaqs, {
                                items: topSupportFaqs
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                    ]
                }));
            }
        }
    ]);
    return SupportIndexPage;
}(react.Component);
SupportIndexPage.getInitialProps = (function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(ctx) {
        var reduxStore, topArticles, promises;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    reduxStore = ctx.reduxStore;
                    topArticles = reduxStore.getState().support.topArticles;
                    promises = [];
                    // Load data
                    !topArticles && promises.push(reduxStore.dispatch((0,actions/* getSupportIndex */.ck)()));
                    _ctx.next = 6;
                    return Promise.all(promises);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
})();
SupportIndexPage.pageLayout = "default";
SupportIndexPage.layoutProps = {
    displaySearch: false
};
/* harmony default export */ var suport_clienti = ((0,es/* connect */.$j)(function(state) {
    return {
        supportCategories: state.support.categories,
        topSupportArticles: state.support.topArticles,
        topSupportFaqs: state.support.topFaqs
    };
})(SupportIndexPage));


/***/ }),

/***/ 3697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eU": function() { return /* binding */ getSupportCategories; },
/* harmony export */   "fk": function() { return /* binding */ getSupportCategoryArticles; },
/* harmony export */   "i_": function() { return /* binding */ getSupportSearchArticles; },
/* harmony export */   "ck": function() { return /* binding */ getSupportIndex; }
/* harmony export */ });
/* harmony import */ var _store_support_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76970);
/* harmony import */ var _lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45963);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2642);



var getSupportCategories = function() {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_CATEGORIES */ .mD,
                success: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_CATEGORIES_SUCCESS */ .$Z,
                fail: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_CATEGORIES_FAILURE */ .mZ
            },
            dispatch: dispatch,
            getState: getState,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getSupportCategoriesApi */ .ePT,
            formatResponse: function(response) {
                return response.data;
            }
        });
    };
};
var getSupportCategoryArticles = function(category) {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_CATEGORY_ARTICLES */ .o4,
                success: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_CATEGORY_ARTICLES_SUCCESS */ .t_,
                fail: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_CATEGORY_ARTICLES_FAILURE */ .sA
            },
            dispatch: dispatch,
            getState: getState,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getSupportCategoryArticlesApi */ .$qG,
            apiArgs: [
                encodeURIComponent(category)
            ],
            formatResponse: function(response) {
                return response.data;
            }
        });
    };
};
var getSupportSearchArticles = function(searchParams) {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_SEARCH_ARTICLES */ .t7,
                success: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_SEARCH_ARTICLES_SUCCESS */ .P9,
                fail: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_SEARCH_ARTICLES_FAILURE */ .bz
            },
            dispatch: dispatch,
            getState: getState,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getSupportSearchArticlesApi */ .amr,
            apiArgs: [
                searchParams
            ],
            formatResponse: function(response) {
                return response.data;
            }
        });
    };
};
var getSupportIndex = function() {
    return function(dispatch, getState) {
        return (0,_lib_api_helpers__WEBPACK_IMPORTED_MODULE_0__/* .makeApiCall */ .Vo)({
            actions: {
                action: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_INDEX */ .c9,
                success: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_INDEX_SUCCESS */ .kA,
                fail: _store_support_constants__WEBPACK_IMPORTED_MODULE_2__/* .GET_SUPPORT_INDEX_FAILURE */ .Ew
            },
            dispatch: dispatch,
            getState: getState,
            apiCall: _lib_api__WEBPACK_IMPORTED_MODULE_1__/* .getSupportIndexApi */ .eBQ,
            formatResponse: function(response) {
                return response.data;
            }
        });
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(38811); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);